import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { motion, useInView } from 'framer-motion'
import { getImageUrl } from '../../utils/getImageUrl'
import { renderColumns } from '../../utils/renderColumns.jsx'
import { getRowData } from './functions'
import { rowStyles, wrapperStyles } from './styles'
import { getValue } from '../../functions'
import { motionStyles } from '../../styles'

ContentForMobile.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
}

function ContentForMobile({ data, loading }) {
  const ref = useRef(null)

  const isInView = useInView(ref, { once: true, amount: 'all' })

  if (isEmpty(data)) return null

  return (
    <div className={wrapperStyles}>
      <h1 className="heading1 leading-none text-center uppercase mt-auto mb-auto" ref={ref}>
        {data?.map((row, index) => {
          const { allImage, allText, columns, rowKey, imageColumn, textColumn } = getRowData(row)

          const rowDelay = index * 0.5

          const textDelay = rowDelay * 0.3
          const imageDelay = rowDelay + 1 * 0.3

          const animate = isInView && !loading ? motionStyles.animate : {}

          if (allImage || allText)
            return (
              <span key={rowKey} className={rowStyles}>
                {renderColumns({ columns, rowDelay, isInView, loading })}
              </span>
            )

          return (
            <span key={rowKey} className={rowStyles}>
              {!isEmpty(textColumn) ? (
                <motion.span
                  initial={motionStyles.initial}
                  animate={animate}
                  transition={{
                    ...motionStyles.transition,
                    delay: textDelay,
                  }}
                >
                  {textColumn?.text}
                </motion.span>
              ) : null}

              {!isEmpty(imageColumn) ? (
                <motion.img
                  className={`my-[14px] max-h-[114px] rounded-pill`}
                  src={getImageUrl(imageColumn)}
                  alt={getValue(imageColumn?.alt)}
                  title={getValue(imageColumn?.title)}
                  description={getValue(imageColumn?.description)}
                  caption={getValue(imageColumn?.caption)}
                  author={getValue(imageColumn?.author)}
                  initial={motionStyles.initial}
                  animate={animate}
                  transition={{
                    ...motionStyles.transition,
                    delay: imageDelay,
                  }}
                />
              ) : null}
            </span>
          )
        })}
      </h1>
    </div>
  )
}

export default React.memo(ContentForMobile)
